import { render, staticRenderFns } from "./WidgetActions.vue?vue&type=template&id=36e053c3&scoped=true"
import script from "./WidgetActions.vue?vue&type=script&lang=js"
export * from "./WidgetActions.vue?vue&type=script&lang=js"
import style0 from "./WidgetActions.vue?vue&type=style&index=0&id=36e053c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e053c3",
  null
  
)

export default component.exports